/* eslint-disable max-len */
import React from 'react';

const BtnEmailIcon: React.FC = (): React.JSX.Element => {
	return (
		<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_215_5)">
				<mask id="mask0_215_5" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="16">
					<path d="M16.5 0H0.5V16H16.5V0Z" fill="white"/>
				</mask>
				<g mask="url(#mask0_215_5)">
					<path fillRule="evenodd" clipRule="evenodd" d="M0.5 3.2747L7.12816 8.28109C7.95718 8.90727 9.11468 8.91889 9.95686 8.3095L16.5 3.57499V12.4173C16.5 13.0483 15.9315 13.6004 15.2817 13.6004H1.71827C1.06853 13.6004 0.5 13.0483 0.5 12.4173V3.2747ZM1.65754 2.40039L8.00076 7.19156C8.32516 7.43659 8.7781 7.44114 9.10765 7.20268L15.7445 2.40039H1.65754Z" fill="#FFBE40"/>
				</g>
			</g>
			<defs>
				<clipPath id="clip0_215_5">
					<rect width="17" height="16" fill="white"/>
				</clipPath>
			</defs>
		</svg>

	);
};

export default BtnEmailIcon;